import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  useCreateAgentSkill,
  useListAgentSkills,
} from '../../api/agent-skills';
import type { CreateAgentSkillInput } from '../../api/agent-skills';
import { useIsAdmin } from '../../components/onboarding-new/api';
import { SkillForm } from '../settings/skills/components/SkillForm';
import { encodeSkillRef } from '../settings/skills/utils/skillRef';
import { getApiErrorMessage } from '../../lib/utils';
import { useState } from 'react';
import { EMPTY_FORM } from '../settings/skills/utils/constants';

import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/skills/new')({
  component: SkillCreatePage,
});

function SkillCreatePage() {
  const { t } = useTranslation('pleri/skills');
  const navigate = useNavigate();
  const createSkill = useCreateAgentSkill();
  const isAdmin = useIsAdmin();
  const { data: skills } = useListAgentSkills();
  const [error, setError] = useState<string | null>(null);

  const tagNames = Array.from(
    new Set((skills ?? []).flatMap((s) => s.tags ?? [])),
  ).sort();

  const handleCreate = async (form: CreateAgentSkillInput) => {
    setError(null);
    try {
      const result = await createSkill.mutateAsync(form);
      navigate({
        to: '/skills/$skillRef',
        params: { skillRef: encodeSkillRef(result.scope, result.name) },
      });
    } catch (err) {
      setError(getApiErrorMessage(err, 'Failed to create skill'));
    }
  };

  return (
    <div className="flex h-full w-full flex-col bg-white dark:bg-gray-900">
      <div className="min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-4xl p-6">
          <SkillForm
            initial={EMPTY_FORM}
            onSave={handleCreate}
            onCancel={() => navigate({ to: '/skills' })}
            isSubmitting={createSkill.isPending}
            isEdit={false}
            isAdmin={isAdmin}
            error={error}
            title={t('newSkill')}
            subtitle={t('givePleriAPlaybookForASpecific')}
            tagNames={tagNames}
          />
        </div>
      </div>
    </div>
  );
}
